import React, { useState } from "react";
import {
  Box, Typography, Alert, CircularProgress, TextField, Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { extractErrorDetail } from "./validators";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

const BRAND = {
  navy: "#00357a",
  navyDark: "#001f4d",
  gold: "#c9a96e",
};

function AdminLogin() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const bg = isDark ? "#080d1a" : "#f4f7ff";
  const cardBg = isDark ? "#111827" : "#ffffff";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`${API_BASE}/admin/login`, {
        email: email.trim().toLowerCase(),
        password,
      });
      localStorage.setItem("admin", JSON.stringify({
        email: res.data.email,
        token: res.data.token,
      }));
      navigate("/admin-dashboard", { replace: true });
    } catch (err) {
      setLoading(false);
      setError(extractErrorDetail(err, "Login failed. Please try again."));
    }
  };

  return (
    <Box sx={{
      minHeight: "100vh", bgcolor: bg,
      display: "flex", alignItems: "center", justifyContent: "center", px: 3,
    }}>
      <Box sx={{
        width: "100%", maxWidth: 400, borderRadius: 3, overflow: "hidden",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,53,122,0.1)"}`,
        boxShadow: isDark
          ? "0 24px 80px rgba(0,0,0,0.5)"
          : "0 24px 80px rgba(0,53,122,0.12)",
        bgcolor: cardBg,
      }}>
        <Box sx={{ height: 4, background: `linear-gradient(to right, ${BRAND.navyDark}, ${BRAND.navy}, ${BRAND.gold})` }} />
        <Box sx={{ bgcolor: BRAND.navy, px: 4, py: 3 }}>
          <Typography sx={{ fontSize: 13.5, fontWeight: 700, letterSpacing: "0.18em", color: BRAND.gold, mb: 1 }}>
            ADMIN ACCESS
          </Typography>
          <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#fff", fontFamily: "'Playfair Display', serif" }}>
            Labarium Admin
          </Typography>
        </Box>

        <Box sx={{ px: 4, py: 4 }}>
          {error && (
            <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2.5, borderRadius: 2, fontSize: 14.5 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              label="Email address" type="email" fullWidth required
              value={email} onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2.5 }}
            />
            <TextField
              label="Password" type="password" fullWidth required
              value={password} onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 3 }}
            />
            <Button type="submit" fullWidth variant="contained" disabled={loading}
              sx={{
                background: `linear-gradient(135deg, ${BRAND.navy} 0%, #004299 100%)`,
                borderRadius: "10px", py: 1.4, fontWeight: 700, textTransform: "none", fontSize: 16,
                "&:hover": { bgcolor: BRAND.navyDark },
              }}>
              {loading ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Sign In"}
            </Button>
          </Box>
          <Typography sx={{ mt: 3, textAlign: "center" }}>
            <Link to="/" style={{ fontSize: 14, color: isDark ? "#94a3b8" : "#64748b" }}>
              ← Back to regular sign in
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default AdminLogin;
